import { IDeveloperField } from 'dromo-uploader-react'
import { OptionsMap } from '../typings'
import { createSelectField } from './createSelectField'
import { taxOptions } from '../constants'
import { createCustomFields } from './createCustomFields'
import { CustomFieldData } from '@user/store/customFields/hooks/useSelectCustomFieldData'

export const leadFieldSettings = (
  options: OptionsMap,
  customFieldsData: CustomFieldData,
  dateFormat: string,
): IDeveloperField[] => {
  const { services, salesFunnelLeadStages, frequencies, users } = options

  return [
    {
      key: 'locationCode',
      label: 'Location Code',
      validators: [
        {
          validate: 'regex_match',
          regex: '^\\d{6,10}$',
          errorMessage:
            'Location Code must contain only digits and be between 6 and 10 characters.',
        },
      ],
    },
    createSelectField(
      'assigneeId',
      'Owner',
      users,
      [{ validate: 'required' }],
      false,
      '',
    ),

    createSelectField(
      'leadFunnelStageName',
      'Lead Status',
      salesFunnelLeadStages,
      [{ validate: 'required' }],
    ),

    // service fields
    createSelectField('serviceName', 'Service Name', services),
    createSelectField('frequencyName', 'Frequency', frequencies),

    { key: 'quantity', label: 'Quantity', type: ['number', 'integer'] },
    {
      key: 'initialPrice',
      label: 'Initial Price',
      type: ['number', 'decimal_2'],
    },
    createSelectField('taxable', 'Taxable (Y/N)', taxOptions),

    // hidden fields
    { key: 'serviceId', label: 'Service Id', hidden: true },
    { key: 'leadFunnelStageId', label: 'Lead Funnel Stage Id', hidden: true },
    { key: 'frequencyId', label: 'Frequency Id', hidden: true },
    { key: 'assigneeName', label: 'assignee Name', hidden: true },
    { key: 'annualOccurrences', label: 'Annual Occurrences', hidden: true },

    ...createCustomFields(customFieldsData, dateFormat),
  ]
}
